(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('search-box-careers');
    const searchInput = form.querySelector("input[name='q']");
    const cards = document.querySelectorAll('.careers-cards');
    const noResult = document.getElementById('careers-no-results');

    form.addEventListener('submit', function (e) {
      e.preventDefault(); // jangan reload halaman
      const keyword = searchInput.value.trim().toLowerCase();
      let matchFound = false;

      cards.forEach((card) => {
        const title = card.querySelector('.job-title').textContent.toLowerCase();
        if (title.includes(keyword)) {
          card.style.display = 'flex';
          matchFound = true;
        } else {
          card.style.display = 'none';
        }
      });

      noResult.style.display = matchFound ? 'none' : 'block';
    });

    // Reset hasil pencarian saat input dikosongkan
    searchInput.addEventListener('input', function () {
      if (searchInput.value.trim() === '') {
        cards.forEach((card) => {
          card.style.display = 'flex';
        });
        noResult.style.display = 'none';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqContainer = document.querySelector('.faqs-container');
    if (!faqContainer) return;

    // Init: set style agar animasi berjalan; tidak mengubah struktur HTML
    faqContainer.querySelectorAll('.faq-item').forEach((item) => {
      const btn = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      if (!btn || !answer) return;

      // Pastikan answer berperilaku collapsible dengan max-height
      answer.style.overflow = 'hidden';
      answer.style.maxHeight = '0';
      answer.style.transition = 'max-height 280ms ease';

      // pastikan aria pada tombol konsisten
      btn.setAttribute('aria-expanded', 'false');

      // keyboard accessibility: buka/tutup dengan Enter/Space
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });

      btn.addEventListener('click', () => {
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';

        // Jika mau behaviour accordion (tutup item lain saat buka satu),
        // uncomment blok berikut (saat ini aktif):
        faqContainer.querySelectorAll('.faq-item').forEach((other) => {
          const obtn = other.querySelector('.faq-question');
          const oans = other.querySelector('.faq-answer');
          if (!obtn || !oans) return;
          if (obtn !== btn) {
            obtn.setAttribute('aria-expanded', 'false');
            oans.style.maxHeight = '0';
          }
        });

        // Toggle current
        btn.setAttribute('aria-expanded', String(!isExpanded));
        if (isExpanded) {
          answer.style.maxHeight = '0';
        } else {
          // set maxHeight ke scrollHeight supaya smooth
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });

    // Recalculate maxHeight ketika jendela di-resize agar tetap cocok
    window.addEventListener('resize', () => {
      faqContainer.querySelectorAll('.faq-item').forEach((item) => {
        const btn = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');
        if (btn && answer && btn.getAttribute('aria-expanded') === 'true') {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let slideIndex = 0;
    let autoSlideTimer;

    function showSlides() {
      const slides = document.querySelectorAll('.slide');
      slides.forEach((slide, index) => {
        slide.style.display = index === slideIndex ? 'block' : 'none';
      });
    }

    function plusSlides(n) {
      const slides = document.querySelectorAll('.slide');
      slideIndex = (slideIndex + n + slides.length) % slides.length;
      showSlides();
      resetAutoSlide();
    }

    function autoSlide() {
      slideIndex = (slideIndex + 1) % document.querySelectorAll('.slide').length;
      showSlides();
    }

    function resetAutoSlide() {
      clearInterval(autoSlideTimer);
      autoSlideTimer = setInterval(autoSlide, 5000);
    }

    autoSlideTimer = setInterval(autoSlide, 5000);

    showSlides();

    document.querySelector('.prev').addEventListener('click', () => plusSlides(-1));
    document.querySelector('.next').addEventListener('click', () => plusSlides(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customs-collections-library"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('lihat-semua-tombol').addEventListener('click', function () {
    const hiddenImages = document.getElementById('hidden-images');
    const button = this;

    if (hiddenImages.classList.contains('visible')) {
      hiddenImages.classList.remove('visible');
      hiddenImages.classList.add('hidden');
      button.textContent = 'Lihat Semua';
    } else {
      hiddenImages.classList.remove('hidden');
      hiddenImages.classList.add('visible');
      button.textContent = 'Tutup';
    }
  });

  // Observasi perubahan jumlah blok pada hidden-images
  const hiddenGrid = document.getElementById('hidden-images');
  const observer = new MutationObserver(() => {
    if (hiddenGrid.classList.contains('visible')) {
      hiddenGrid.style.maxHeight = `${hiddenGrid.scrollHeight}px`;
    }
  });

  observer.observe(hiddenGrid, { childList: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const regions = document.querySelectorAll('.map-region');
    const infoBox = document.getElementById('info-box');
    let activeRegion = null;

    const truncateText = (text, maxLength = 20) => {
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    const fetchProductData = async (handle) => {
      if (!handle) return null;
      try {
        const response = await fetch(`/products/${handle}.json`);
        if (response.ok) {
          return await response.json();
        }
      } catch (error) {
        console.error(`Gagal mengambil produk ${handle}:`, error);
      }
      return null;
    };

    const setInfoBoxContent = async (region) => {
      if (!region) return;

      const title = region.getAttribute('data-title');
      const cities = region.getAttribute('data-cities');
      const description = region.getAttribute('data-description');
      const link = region.getAttribute('data-link');
      const images = Array.from({ length: 4 }, (_, i) => region.getAttribute(`data-image${i + 1}`)).filter(Boolean);
      const productHandles = Array.from({ length: 4 }, (_, i) => region.getAttribute(`data-product${i + 1}`)).filter(
        Boolean,
      );

      infoBox.classList.remove('visible');
      infoBox.innerHTML = `
            <div class="info-images">
                ${images.map((img) => `<img src="${img}" width="200" height="100" alt="${title}" class="info-image" loading="lazy">`).join('')}
            </div>
            <div class="text-info">
                <h3 class="heading-text">${title}</h3>
                <p class="cities">${cities}</p>
                <p class="description">${description}</p>
                <b class="activities">Aktivitas terkait</b>
                <div class="product-assign">
                  ${productHandles.map(() => '<div class="product-item"><span>Loading Produk...</span></div>').join('')}
                </div>
                <a href="${link}" class="more-link">Selengkapnya &rarr;</a>
            </div>
        `;

      const products = await Promise.all(productHandles.map(fetchProductData));
      let productHTML = '';

      products.forEach((product) => {
        if (product) {
          const truncatedTitle = truncateText(product.product.title, 20);
          const productURL = `/products/${product.product.handle}`;
          productHTML += `
                    <a href="${productURL}" class="product-link" target="_blank">
                        <div class="product-item">
                            <img src="${product.product.images[0]?.src}&width=300&height=300&crop=top" alt="product img loading="lazy">
                            <span>${truncatedTitle}</span>
                        </div>
                    </a>
                `;
        }
      });

      const productContainer = infoBox.querySelector('.product-assign');
      if (productContainer) {
        productContainer.innerHTML = productHTML || '<p>Tidak ada produk terkait</p>';
      }

      infoBox.style.display = 'block';
      requestAnimationFrame(() => {
        infoBox.classList.add('visible');
      });
    };

    const highlightRegion = (region) => {
      if (activeRegion) {
        activeRegion.classList.remove('active-region');
        const oldPath = activeRegion.querySelector('path');
        if (oldPath) oldPath.classList.remove('active-region');
      }

      region.classList.add('active-region');
      const path = region.querySelector('path');
      if (path) path.classList.add('active-region');

      setInfoBoxContent(region);
      activeRegion = region;
    };

    regions.forEach((region) => {
      region.addEventListener('mouseenter', () => {
        if (activeRegion !== region) {
          highlightRegion(region);
        }
      });

      region.addEventListener('click', () => {
        if (activeRegion !== region) {
          highlightRegion(region);
        }
      });
    });

    if (regions.length > 0) {
      highlightRegion(regions[2]);
    }

    document.addEventListener('click', (event) => {
      if (event.target.id === 'prev-region' || event.target.closest('#prev-region')) {
        let currentIndex = Array.from(regions).indexOf(activeRegion);
        let prevIndex = (currentIndex + 1) % regions.length;
        highlightRegion(regions[prevIndex]);
      }

      if (event.target.id === 'next-region' || event.target.closest('#next-region')) {
        let currentIndex = Array.from(regions).indexOf(activeRegion);
        let nextIndex = (currentIndex - 1 + regions.length) % regions.length;
        highlightRegion(regions[nextIndex]);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
